export function selectNutritionPlanFoodPickerSearchText({
  input,
  searchText = "",
  scheduleSelection,
}) {
  const selectionEnd = String(searchText ?? "").length;
  if (selectionEnd === 0 || typeof scheduleSelection !== "function") {
    return false;
  }

  scheduleSelection(() => {
    if (!input) {
      return;
    }

    input.setSelectionRange?.(0, selectionEnd);
    input.select?.();
    input.setNativeProps?.({
      selection: { start: 0, end: selectionEnd },
    });
  });

  return true;
}

export function focusNutritionPlanFoodPickerSearchInput({
  input,
  isInputPressing = false,
  ignorePressGuard = false,
  selectText = false,
  searchText = "",
  scheduleSelection,
}) {
  if (isInputPressing && !ignorePressGuard) {
    return false;
  }

  input?.focus?.();

  if (selectText) {
    selectNutritionPlanFoodPickerSearchText({
      input,
      searchText,
      scheduleSelection,
    });
  }

  return true;
}

export function restoreNutritionPlanFoodPickerSearchAfterSelection({
  focusSearchInput,
  scheduleFocus,
}) {
  if (typeof focusSearchInput !== "function") {
    return false;
  }

  const applyFocus = () => {
    focusSearchInput({
      selectText: true,
      ignorePressGuard: true,
    });
  };

  if (typeof scheduleFocus === "function") {
    scheduleFocus(applyFocus);
    return true;
  }

  if (typeof requestAnimationFrame === "function") {
    requestAnimationFrame(applyFocus);
    return true;
  }

  setTimeout(applyFocus, 0);
  return true;
}
